var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("span", {
    staticClass: "bg-color-slide",
    style: `width: ${_vm.width}; height: ${_vm.height}; border-radius: ${_vm.borderRadius}px;`,
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }